// Module-scoped endpoint paths for offering detail.
// Listing/filter/bookmark live in the offerings/browse sub-module.

export const PROPERTY_ENDPOINTS = {
  PROPERTY_DETAIL: '/api/offerings/{offeringId}',
} as const
